import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

const fetch = (courseId: number, courseDocumentId: number): AxiosPromise<CourseDocumentExtraPageApi[]> => {
  return api.get<CourseDocumentExtraPageApi[]>(endpoints.COURSE_DOCUMENTS.EXTRA_PAGES.GET(courseId, courseDocumentId));
};

const upload = (
  courseId: number,
  courseDocumentId: number,
  file: File,
  order: number
): AxiosPromise<CourseDocumentExtraPageApi> => {
  const formData = new FormData();
  formData.append("File", file);
  formData.append("Order", order.toString());

  return api.post<CourseDocumentExtraPageApi>(
    endpoints.COURSE_DOCUMENTS.EXTRA_PAGES.CREATE(courseId, courseDocumentId),
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

const deleteExtraPage = (
  courseId: number,
  courseDocumentId: number,
  pageId: number
): AxiosPromise => {
  return api.delete(endpoints.COURSE_DOCUMENTS.EXTRA_PAGES.DELETE(courseId, courseDocumentId, pageId));
};

const reorder = (
  courseId: number,
  courseDocumentId: number,
  pageOrders: Record<string, number>
): AxiosPromise => {
  return api.put(endpoints.COURSE_DOCUMENTS.EXTRA_PAGES.REORDER(courseId, courseDocumentId), {
    PageOrders: pageOrders,
  });
};

export const courseDocumentExtraPagesApi = {
  fetch,
  upload,
  delete: deleteExtraPage,
  reorder,
};

export interface CourseDocumentExtraPageApi {
  id: number;
  courseDocumentId: number;
  fileName: string;
  blobName: string;
  fileType: CourseDocumentExtraPageType;
  order: number;
  createdDate: Date;
  lastModified: Date;
}

export enum CourseDocumentExtraPageType {
  PDF = 1,
  DOCX = 2,
}

export interface ReorderExtraPagesRequest {
  pageOrders: Record<string, number>;
}